import request from '@/utils/request.js'
import Config from '@/config/app.js'

let wxUseUrl = Config.wxUseUrl;



/**
 * 微信签名
 * @param params
 * @returns {AxiosPromise}
 */
export function wxSignatureApi(params) {
    return request({
        closeLoading: true,
        url: wxUseUrl + '/hsjmp/mp/wxSignature',
        method: 'get',
        params: params
    })
}


